// NASEPTAVANI VYHLEDAVANI
$('#search-form').bind("submit", function (e) {
	e.preventDefault();
	return false;
});

$('#search-form input[name=q]').bind("keypress", function (e) {
	if (e.keyCode == 13) {
		if (!$('.hintserver-suggestions').is(":visible")) {
			$('.hintserver-suggestions').show();
		}
		return false;
	}
});

$('#search-form input[name=q]').hintserver({
	serviceUrl: '/ajax/snippet/hint',
	type: 'POST',
	params: {
		query: $('input[name=q]').val(),
		count: 50
	},
	preserveInput: true,
	minChars: 1,
	deferRequestBy: 800,
	appendTo: $('#search-form .search'),
	transformResult: function (response) {
		if (response === undefined) {
			return {
				suggestions: []
			};
		}

		const res = JSON.parse(response);
		if (res.empty) {
			$("#search-form .hintserver-suggestions").addClass("hint--empty");
		} else {
			$("#search-form .hintserver-suggestions").removeClass("hint--empty");
		}
		trackHint(res.items);
		return {
			suggestions: $.map(res.items, function (item) {
				return {
					value: item,
					data: {
						html: item
					}
				};
			})
		};
	},
	formatResult: function (suggestion, currentValue) {
		return suggestion.data.html;
	},
	onSelect: function (suggestion) {
		$('#search-form input[name=q]').val('');
		return false;
	}
});

function trackHint(items) {
	if (window.dataLayer && items.length) {
		dataLayer.push({
			"event": "search_suggest_view",
			"search": {
				"term": document.getElementById('search').value,
				"results": {
					"count": {
						"total": items.length,
						"products": items.length
					},
				},
				"personalized": false
			},
			_clear: true
		});
	}
}